import { folderDetailsActionTypes } from './Constants';

export function getFolderDetailsRequest(id) {
	return {
		type: folderDetailsActionTypes.GET_FOLDER_DETAILS_REQUEST,
		payload: {
			id,
		},
	};
}

export function getFolderDetailsSuccess(data) {
	return {
		type: folderDetailsActionTypes.GET_FOLDER_DETAILS_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getFolderDetailsError() {
	return {
		type: folderDetailsActionTypes.GET_FOLDER_DETAILS_ERROR,
	};
}

export function toggleAddListModal(status) {
	return {
		type: folderDetailsActionTypes.TOGGLE_FOLDER_ADD_LIST_MODAL,
		payload: {
			status,
		},
	};
}

export function addItemsRequest(id, practiceableItems) {
	return {
		type: folderDetailsActionTypes.FOLDER_ADD_ITEMS_REQUEST,
		payload: {
			id,
			practiceableItems,
		},
	};
}

export function addItemsSuccess() {
	return {
		type: folderDetailsActionTypes.FOLDER_ADD_ITEMS_SUCCESS,
		payload: {},
	};
}

export function addItemsError() {
	return {
		type: folderDetailsActionTypes.FOLDER_ADD_ITEMS_ERROR,
	};
}

export function updateFolderRequest(folderId, options, openFrom, showNotification = true) {
	return {
		type: folderDetailsActionTypes.UPDATE_FOLDER_REQUEST,
		payload: {
			folderId,
			options,
			openFrom,
			showNotification,
		},
	};
}

export function updateFolderSuccess(data) {
	return {
		type: folderDetailsActionTypes.UPDATE_FOLDER_SUCCESS,
		payload: {
			data,
		},
	};
}

export function updateFolderError() {
	return {
		type: folderDetailsActionTypes.UPDATE_FOLDER_ERROR,
	};
}

export function deleteFolderRequest(folderId) {
	return {
		type: folderDetailsActionTypes.DELETE_FOLDER_REQUEST,
		payload: {
			folderId,
		},
	};
}

export function deleteFolderError() {
	return {
		type: folderDetailsActionTypes.DELETE_FOLDER_ERROR,
	};
}

export function deleteListFromFolderRequest(data) {
	return {
		type: folderDetailsActionTypes.DELETE_LIST_FROM_FOLDER_REQUEST,
		payload: {
			data,
		},
	};
}

export function deleteListFromFolderSuccess(data) {
	return {
		type: folderDetailsActionTypes.DELETE_LIST_FROM_FOLDER_SUCCESS,
		payload: {
			data,
		},
	};
}

export function deleteListFromFolderError() {
	return {
		type: folderDetailsActionTypes.DELETE_LIST_FROM_FOLDER_ERROR,
	};
}

export function clearFolderDetails() {
	return {
		type: folderDetailsActionTypes.CLEAR_FOLDER_DETAILS,
		payload: {},
	};
}
